import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from '../shared/error';
import { internalLayerVersionsKeys } from './queryKeys';
import type { InternalLayerVersion } from 'hooks/internalLayerVersion/types';
import type { InternalLayer } from 'hooks/internalLayer/types';

type CreateDraftResponse = {
  layer: InternalLayer;
  version: InternalLayerVersion;
};

export function useCreateDraftInternalLayerVersionMutation() {
  const queryClient = useQueryClient();

  return useMutation<CreateDraftResponse, unknown, { internalLayerId: UUID }>({
    mutationFn: async ({ internalLayerId }) => {
      const resp = await axios.post<CreateDraftResponse>(
        `${config.apiGateway.internal_layers}/${internalLayerId}/draft`
      );
      return resp.data;
    },
    onSuccess: () => {
      toast.success('New draft version created');
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: internalLayerVersionsKeys.all(),
      });
    },
  });
}
